module.exports = __webpack_public_path__ + "static/media/Lab_Partner_3_PCR_Product.9bf65f17.svg";